import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '../Components/SearchBar'
import { Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import authInstance from '../Classes/AuthHandler';
import { getAllPOItemDetails, getAllDetailsOfPOForDispatchForSupplier } from '../store/actions/dispatchOrderDetailsActions'
import { connect } from 'react-redux'
import AuthHandlerInstance from '../Classes/AuthHandler'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'


// function formatDate(date) {
//   var d = new Date(date),
//     month = '' + (d.getMonth() + 1),
//     day = '' + d.getDate(),
//     year = d.getFullYear();

//   if (month.length < 2)
//     month = '0' + month;
//   if (day.length < 2)
//     day = '0' + day;

//   return [day, month, year].join('-');
// }


class DispatchUploadClearence extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      PoNumber: this.props.location.state.poId,
      supId: this.props.location.state.supId,
      OrderId: this.props.location.state.OrderId,
      ProjectId: this.props.location.state.ProjectId,
      select: false,
      open: false,
      selectAll: false,
      checked: [],
      checksupplier: [],
      selected: [],
      opacity: "",
      multiCollapseIndex: "",
      checkedArray: [],
      poItemChecked: [],
      singleselectchecked: [],
      // tableData:[
      //   {   value: 1, PONo: "47000026941" ,POItem:"10",Supplier:"ABC pvt. ltd.",CreatedOn:"01-02-2020",POAmount:"1456789",WBSNo:"AO001",Location:"Chennai",Status:"Inspection Clearence",Comment:""  },
      //   {   value: 2, PONo: "47000026941" ,POItem:"11",Supplier:"CDE pvt. ltd.",CreatedOn:"01-03-2020",POAmount:"145009" ,WBSNo:"AO001",Location:"Karnataka",Status:"Inspection Clearence",Comment:""     },
      //   {   value: 3, PONo: "47000026941" ,POItem:"12",Supplier:"EFG pvt. ltd.",CreatedOn:"01-04-2020",POAmount:"145669"  ,WBSNo:"AO001",Location:"Mumbai",Status:"Inspection Clearence",Comment:""    },
      //   {   value: 4, PONo: "47000026941" ,POItem:"13",Supplier:"HIJ pvt. ltd.",CreatedOn:"05-05-2020",POAmount:"1456200" ,WBSNo:"AO001",Location:"Chennai",Status:"Inspection Clearence",Comment:""     }],


    }
    this.handleUpload = this.handleUpload.bind(this);
    this.togglebutton = this.togglebutton.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSingleCheckboxChange = this.handleSingleCheckboxChange.bind(this)



  }
  action1() {
    this.setState({ action1: false });
  }



  togglebutton = (Index) => {
    // const { open } = this.state;  
    // this.setState({  
    //     open: !open,  
    // }); 
    var multiCollapseIndex = this.state.multiCollapseIndex
    if (multiCollapseIndex != Index || multiCollapseIndex == '') {
      this.setState({ multiCollapseIndex: Index })
    }
  }

  handleChange = () => {
    var selectAll = !this.state.selectAll;
    let selected = this.state.selected;
    let select = !this.state.select;
    this.setState({ selectAll });
    var checkedCopy = [];
    this.props.itemdetails.allPoItemDetails.recordset.map(function (e, index) {
      checkedCopy.push(e);
    });
    console.log(checkedCopy, '@@@@@@@@@@@@@@@', selectAll)
    if (selectAll) {
      this.setState({
        checked: checkedCopy
      });
      console.log(this.state.checked)
    } else {
      this.setState({
        checked: []
      });
    }

    // var checkedArray = this.state.checkedArray
    // console.log(checkedArray)
    // this.props.itemdetails.allPoItemDetails.recordset.map((item,index)=>{
    //   selected[index] = selectAll;
    //   if(select==true){
    //       checkedArray.push(item.PoItems)
    //   }else{
    //     checkedArray=[]
    //   }
    // });
    // this.setState({selected: selected, select:select,checkedArray});

  }
  //   try{
  //     let selected = this.state.selected;
  //     let select = !this.state.select;
  //     var checkedArray = this.state.checkedArray
  //     //console.log(select,'??????////')
  //     this.props.itemdetails.allPoItemDetails.recordset.map(function(e, index){
  //       // selected[e.PurchaseOrderLineId] = select;
  //       // if(select==true){
  //       //     checkedArray.push(e.PurchaseOrderLineId)
  //       // }else{
  //       //   checkedArray=[]
  //       // }
  //       console.log(e)
  //     });


  //     this.setState({selected: selected, select:select,checkedArray});
  //   }catch(e){
  //     console.log(e);
  //   }

  // };

  // handleSingleCheckboxChange = index => {
  //   let checkedArray = this.state.checkedArray;
  //   console.log(index,'@@@@@@@@@@@@@@');
  //   checkedArray.push(index)
  //   var checkedCopy = this.state.checked;
  //   checkedCopy[index] = !this.state.checked[index];
  //   if (checkedCopy[index] === false) {
  //     this.setState({ selectAll: false });
  //   }
  //   this.setState({
  //     checked: checkedArray
  //   },()=>console.log(this.state.checked,'!!!!!!!!!!!!'));
  // };

  handleSingleCheckboxChange = index => {
    let checked= this.state.checked
    var checkedArray = this.state.checkedArray
    let selected = this.state.selected;
    let status = index in selected ? !selected[index] : true
    selected[index] = status
    if (selected[index] == true) {
      checkedArray.push(index)
    } else {
      var index = checkedArray.indexOf(index);
      if (index !== -1) {
        checkedArray.splice(index, 1);
      }
    }

    for(let x in selected){
      checked.push(this.props.itemdetails.allPoItemDetails.recordset[x])
    }
    console.log(checked)
    this.setState({ selected, checkedArray, checked});
    // console.log(checkedArray, selected)
  };

  toggleVersionModal(e) {
    this.setState({ OpenVersionModal: !this.state.OpenVersionModal });
  }

  toggleSuccessModal(e) {
    this.setState({ UploadSuccessModal: !this.state.UploadSuccessModal });
    if (this.state.UploadSuccessModal == true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
    }
  }

  // ? handle search input
  handleISearch = (e) => {
    let searchInput = e.target.value
    this.setState({
      searchInput
    })
    console.log(this.state.searchInput)
  }
  // ? handle searching
  handleSearching = async () => {

    var userId = AuthHandlerInstance.getUserID()
    let searchTerm = this.state.searchInput
    await this.props.getSupplierPOs(userId, searchTerm)
    console.log("Search complete, results are : ", this.props.supplier.pos)
    await this.setState({ tableData: this.props.supplier.pos, searchInput: "" })

  }

  handleUpload() {
    console.log(this.state.checked, "checked:")
  }

  componentDidMount() {
    // params for POItem details store
    var input_obj = {
      "POSAPid": this.state.PoNumber,
      "OrderId": this.state.OrderId,
      "ProjectId": this.state.ProjectId,
      "SearchTerm": ""
    }
    this.props.getAllPOItemDetails(input_obj)
    var data_obj = {
      "POSAPid": this.state.PoNumber,
      "VendorId": this.state.supId,
      "SearchTerm": ""
    }

    this.props.getAllDetailsOfPOForDispatchForSupplier(data_obj)
    // console.log(this.props.getAllDetailsOfPOForDispatchForSupplier, '##########')  
  }

  render() {
    // console.log(this.props.itemdetails.allPoItemDetails.recordset, "....")
    var roles = authInstance.getRoles()
    var groups = authInstance.getGroups()
    // console.log("roles",roles);
    return (
      <div className="Container-fluid pageheight"  >


        <div className="Container-fluid p-4" style={{ opacity: this.state.opacity }}>
          <div className="row pr-4 pt-2" >
            <div className="col-md-4 header ">
             <b>PO No: </b> {this.state.PoNumber}
            </div>
            {/* <div className="col-md-4 header ">
                       <button className="btn2 btn-sms1  float-right mr-4  "  >Upload</button>
                    </div> */}
            {
              // for other teams of sms
              roles[6] || roles[9] || roles[13] || roles[14] || roles[15] || roles[16] ?
                <div className="col-md-4 ">
                  <Link to={{ pathname: '/UploadDispatchPOItem', state: { Po: this.state.PoNumber, checked: this.state.checked } }}>
                    <button className="btn2 btn-sms1 mr-4 mt-2 float-right" type="submit">Uploaded Documents</button>
                  </Link>
                </div>
                :
                //  for tpm
                roles[12] ? <>
                  <div className="col-md-4 ">
                    <Link to={{ pathname: '/DashboardTPM', state: { Po: this.state.PoNumber, checked: this.state.checked} }}>
                      <div><button className="btn2 btn-sms1 mt-2   float-right mr-4  " onClick={this.handleUpload} >Upload Dispatch Documents</button></div>
                    </Link>
                  </div></>
                  //  for supplier
                  : <div className="col-md-4 "></div>
            }



            <div className="col-md-4 pt-2  xs={last}">
              <SearchBar placeholder="Search" value={this.state.searchInput} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" btnName="" />
            </div>
          </div>

          <div className="row-md-8 pr-4">
            <div className="col ">
              <div className="row  headerbar ">
                {/* for Supplier  */}
                {roles[5] ? <>
                  {/* <div className="col-md-1 pt-2 pb-2 checkboxheaderbar borderheaderbar ">
                      <input type="checkbox" onClick={this.handleChange} checked={this.state.selectAll} />
                    </div> */}
                  <div className="col-md-2 pt-2 pb-2 borderheaderbar">PO Number</div>
                  <div className="col-md-3 pt-2 pb-2 borderheaderbar">PO Item Number</div>
                  <div className="col-md-3 pt-2 pb-2 borderheaderbar">Created On</div>
                  <div className="col-md-2 pt-2 pb-2 borderheaderbar ">PO Amount</div>
                  <div className="col-md-2 pt-2 pb-2 borderheaderbar">Action</div></>

                  :
                  roles[6] ? <>

                  <div className="col-md-3 pt-2 pb-2 borderheaderbar">PO Number</div>
                  <div className="col-md-2 pt-2 pb-2 borderheaderbar">PO Item Number</div>
                  <div className="col-md-3 pt-2 pb-2 borderheaderbar">Created On</div>
                  <div className="col-md-2 pt-2 pb-2 borderheaderbar ">PO Amount</div>
                  <div className="col-md-2 pt-2 pb-2 borderheaderbar">Action</div></>

                  :
                  // for TPM
                  roles[12] ? <>


                    <div className="col-md-1 pt-2 pb-2 checkboxheaderbar borderheaderbar ">
                      <input type="checkbox" onClick={this.handleChange} checked={this.state.selectAll} />
                    </div>
                    <div className="col-md-2 pt-2 pb-2 borderheaderbar">PO Number</div>
                    <div className="col-md-2 pt-2 pb-2 borderheaderbar">PO Item Number</div>
                    <div className="col-md-3 pt-2 pb-2 borderheaderbar">Supplier</div>
                    <div className="col-md-2 pt-2 pb-2 borderheaderbar">Created On</div>
                    <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">PO Amount</div></>

                    :
                    // for other team of sms
                    roles[6] || roles[9] || roles[13] || roles[14] || roles[15] || roles[16] ? <>


                      <div className="col-md-3 pt-2 pb-2 borderheaderbar">PO Number</div>
                      <div className="col-md-2 pt-2 pb-2 borderheaderbar">PO Item Number</div>
                      <div className="col-md-3 pt-2 pb-2 borderheaderbar">Supplier</div>
                      <div className="col-md-2 pt-2 pb-2 borderheaderbar">Created On</div>
                      <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">PO Amount</div></>
                      : <></>
                }
              </div>
              {this.props.itemdetails.allPoItemDetails && this.props.itemdetails.allPoItemDetails.recordset && this.props.itemdetails.allPoItemDetails.recordset.length > 0 && this.props.itemdetails.allPoItemDetails.recordset.map((element, Index) =>
                //  {this.state.tableData.map((element,Index)=>
                <div className={Index % 2 == 0 ? 'row border ' : 'row  background '}
                  onClick={() => this.togglebutton(Index)} data-toggle="collapse" data-target={`.multi-collapse${Index}`}>
                  {/* for Supplier */}
                  {roles[5] ?
                    <>
                     {/* <div className="col-md-1 pt-2 pb-2 borderheaderbar">
                          <input
                            type="checkbox" disabled={element.Status==6?true:false} checked={this.state.checked[Index]} onChange={() => this.handleSingleCheckboxChange(Index)} />
                        </div> */}
                      <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{element.PoNo}</div>
                      <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign">{element.PoItems}</div>
                      <div className="col-md-3 pt-2 pb-2 borderheaderbar d-none d-sm-block headeralign">{dateFormater(element.POCreatedOn)}</div>
                      <div className="col-md-2 pt-2 pb-2 borderheaderbar amount-text headeralign">{numberWithCommas(element.POLineItemAmount)}</div>
                      <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign ">
                        <Link to={{ pathname: '/DashboardTPM', state: { Po: element.PoNo, POItem: element.PoItems, checked: this.state.checksupplier,WBSNo: element.WBSNo,Status:element.Status, PurchaseOrderId : element.POID, PurchaseOrderLineItemId: element.PurchaseOrderLineId } }}>
                          <FontAwesomeIcon icon={"eye"} color="black" title="View" size="lg" />
                        </Link>
                      </div>
                    </>
                    :
                    // qa planner
                    roles[6] ?
                    <>
                      <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign">{element.PoNo}</div>
                      <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{element.PoItems}</div>
                      <div className="col-md-3 pt-2 pb-2 borderheaderbar d-none d-sm-block headeralign">{dateFormater(element.POCreatedOn)}</div>
                      <div className="col-md-2 pt-2 pb-2 borderheaderbar amount-text headeralign">{numberWithCommas(element.POLineItemAmount)}</div>
                      <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign ">
                        <Link to={{ pathname: '/DashboardTPM', state: { Po: element.PoNo, POItem: element.PoItems, checked: this.state.checksupplier,WBSNo: element.WBSNo,Status:element.Status, PurchaseOrderId : element.POID, PurchaseOrderLineItemId: element.PurchaseOrderLineId } }}>
                          <FontAwesomeIcon icon={"eye"} color="black" title="View" size="lg" />
                        </Link>
                      </div>
                    </>
                    :
                    // for tpm 
                    roles[12] ?
                      <>
                        <div className="col-md-1 pt-2 pb-2 borderheaderbar">
                          <input
                            type="checkbox" disabled={element.Status==6?true:false} checked={this.state.checked[Index]} onChange={() => this.handleSingleCheckboxChange(Index)} />
                        </div>
                        <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{element.PoNo}</div>
                        <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{element.PoItems}</div>
                        <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign">{element.Supplier}</div>
                        <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block headeralign">{dateFormater(element.POCreatedOn)}</div>
                        <div className="col-md-2 pt-2 pb-2 borderheaderbar amount-text headeralign">{numberWithCommas(element.Currency + ' ' + element.POLineItemAmount)}</div>
                      </>
                      :
                      //  for other supplier teams
                      roles[6] || roles[9] || roles[13] || roles[14] || roles[15] || roles[16] ?
                        <>

                          <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign">{element.PoNo}</div>
                          <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{element.PoItems}</div>
                          <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign">{element.Supplier}</div>
                          <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block headeralign">{dateFormater(element.POCreatedOn)}</div>
                          <div className="col-md-2 pt-2 pb-2 borderheaderbar amount-text headeralign">{numberWithCommas(element.Currency + ' ' + element.POLineItemAmount)}</div>
                        </>
                        :
                        <></>

                  }




                  <div style={{maxWidth:"1400px"}}  className={Index == this.state.multiCollapseIndex ? ` pt-2 mb-2 detailpanebackground container collapse multi-collapse${Index}` : `container collapse`}>
                    <form>
                      <div></div>


                      <div className="row">
                        <div className="col-md-2">
                          <b>WBS Number:</b>
                        </div>
                        <div className="col">
                          {element.WBSNo}
                        </div>

                        <div className="col-md-3">
                          <b>Location:</b>
                        </div>
                        <div className="col">
                          {element.Location}
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-2">
                          <b>DC Document:</b>
                        </div>
                        <div className="col">
                          XXX
                                                </div>
                        <div className="col-md-3">
                          <b>Status:</b>
                        </div>
                        <div className="col">
                          {element.Status}
                        </div>

                      </div>

                      <div className="row">
                        <div className="col-md-2">
                          <b>Comment:</b>
                        </div>
                        <div className="col">
                          {element.Comment}
                        </div>
                        <div className="col-md-3">
                          <b>PO Quantity:</b>
                        </div>
                        <div className="col">
                          {element.POLineItemQuantity + ' ' + element.OrderUnit}
                        </div>

                      </div>

                      <div className="row">
                        <div className="col-md-2">
                          <b>Item Description:</b>
                        </div>
                        <div className="col">
                          ABC
                        </div>
                        <div className="col-md-3">
                          <b>Inspected/Cleared Quantity:</b>
                        </div>
                        <div className="col">
                          {element.POLineItemQuantity + ' ' + element.OrderUnit}
                        </div>

                      </div>


                      <div className="row d-block d-sm-none">
                        <div className="col-md-2">
                          <b>Status:</b>
                        </div>
                        <div className="col">
                          1001
                                                </div>

                      </div>

                    </form>
                  </div>
                </div>
              )}

            </div>
          </div>

        </div>
      </div>

    )
  }
}


const mapStateToProps = (state) => ({ itemdetails: state.dispatchOrderDetailsReducer, supplierDetails: state.dispatchOrderDetailsReducer })
export default connect(mapStateToProps, { getAllPOItemDetails, getAllDetailsOfPOForDispatchForSupplier })(DispatchUploadClearence);